var exports = {
  "k": "x61f99309--6e3411--container",
};

module.exports = exports;
